interface IConfig {
  ASSETS: string;
  API: string;
  FRONTLINE_API: string;
  MANAGER_PORTAL: string;
}

const BASE_CONFIG = {
  ASSETS: 'https://assets-public-prod-eu-central-1.quinyx.com',
};

const getEnvironmentUrls = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost') {
      return {
        API: 'https://web-test.quinyx.com/extapi',
        FRONTLINE_API: 'https://web-test.quinyx.com/extapi/v1/frontline',
        MANAGER_PORTAL: 'http://local.web-test.quinyx.com',
      };
    }
    const { hostname } = window.location || {};
    const envMatch = hostname.match(/^admin(?:-(.+))?\.quinyx\.com$/);
    const env = envMatch?.[1] || '';
    const quinyxWebURL = env
      ? `https://web-${env}.quinyx.com`
      : 'https://web.quinyx.com';
    return {
      API: `${quinyxWebURL}/extapi`,
      FRONTLINE_API: `${quinyxWebURL}/extapi/v1/frontline`,
      MANAGER_PORTAL: quinyxWebURL,
    };
  }
  // server side:
  return {
    API: 'https://web-test.quinyx.com/extapi',
    FRONTLINE_API: 'https://web-test.quinyx.com/extapi/v1/frontline',
    MANAGER_PORTAL: 'https://web-test.quinyx.com',
  };
};

export const CONFIG: IConfig = {
  ...BASE_CONFIG,
  ...getEnvironmentUrls(),
};
